export const FULFILLED = "_FULFILLED";
export const REJECTED = "_REJECTED";
export const PENDING = "_PENDING";